import FemaleAthleticTShirt from '../FemaleShirts/AthleticTShirt'
import FemaleFlowers from '../FemaleShirts/Flowers'
import FemaleOveralls from '../FemaleShirts/Overalls'
import FemaleSuit from '../FemaleShirts/Suit'
import FemaleWideNeckSlit from '../FemaleShirts/WideNeckSlit'
import FemaleBaseball from '../FemaleShirts/Baseball'
import FemaleHeart from '../FemaleShirts/Heart'
import FemaleRey from '../FemaleShirts/Rey'
import FemaleTShirt from '../FemaleShirts/TShirt'
import FemaleWideRuffleNeck from '../FemaleShirts/WideRuffleNeck'
import FemaleBowtie from '../FemaleShirts/Bowtie'
import FemaleHexagonNeck from '../FemaleShirts/HexagonNeck'
import FemaleRoundCollar from '../FemaleShirts/RoundCollar'
import FemaleTie from '../FemaleShirts/Tie'
import FemaleWideVNeck from '../FemaleShirts/WideVNeck'
import FemaleCardigan from '../FemaleShirts/Cardigan'
import FemaleHoodie from '../FemaleShirts/Hoodie'
import FemaleRuffledSleeves from '../FemaleShirts/RuffledSleeves'
import FemaleTiedye from '../FemaleShirts/Tiedye'
import FemaleCollaredColored from '../FemaleShirts/CollaredColored'
import FemaleJeanJacket from '../FemaleShirts/JeanJacket'
import FemaleScarf from '../FemaleShirts/Scarf'
import FemaleTurtleNeck from '../FemaleShirts/TurtleNeck'
import FemaleCollaredJacket from '../FemaleShirts/CollaredJacket'
import FemaleJersey from '../FemaleShirts/Jersey'
import FemaleStar from '../FemaleShirts/Star'
import FemaleVNeckDeep from '../FemaleShirts/VNeckDeep'
import FemaleCollaredPlain from '../FemaleShirts/CollaredPlain'
import FemaleLeatherJacket from '../FemaleShirts/LeatherJacket'
import FemaleStripped from '../FemaleShirts/Stripped'
import FemaleVneck from '../FemaleShirts/Vneck'
import FemaleButton from '../FemaleShirts/3button'
import FemaleFloral from '../FemaleShirts/Floral'
import FemaleMarshmallowJacket from '../FemaleShirts/MarshmallowJacket'
import FemaleStrippedCollar from '../FemaleShirts/StrippedCollar'
import FemaleWideNeck from '../FemaleShirts/WideNeck'

const defaultY = 120

const data = [
  {
    id: 'FemaleAthleticTShirt',
    svg: FemaleAthleticTShirt,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleFlowers',
    svg: FemaleFlowers,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleOveralls',
    svg: FemaleOveralls,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleSuit',
    svg: FemaleSuit,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleWideNeckSlit',
    svg: FemaleWideNeckSlit,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleBaseball',
    svg: FemaleBaseball,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleHeart',
    svg: FemaleHeart,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleRey',
    svg: FemaleRey,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleTShirt',
    svg: FemaleTShirt,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleWideRuffleNeck',
    svg: FemaleWideRuffleNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleBowtie',
    svg: FemaleBowtie,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleHexagonNeck',
    svg: FemaleHexagonNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleRoundCollar',
    svg: FemaleRoundCollar,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleTie',
    svg: FemaleTie,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleWideVNeck',
    svg: FemaleWideVNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleCardigan',
    svg: FemaleCardigan,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleHoodie',
    svg: FemaleHoodie,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleRuffledSleeves',
    svg: FemaleRuffledSleeves,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleTiedye',
    svg: FemaleTiedye,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleCollaredColored',
    svg: FemaleCollaredColored,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleJeanJacket',
    svg: FemaleJeanJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleScarf',
    svg: FemaleScarf,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleTurtleNeck',
    svg: FemaleTurtleNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleCollaredJacket',
    svg: FemaleCollaredJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleJersey',
    svg: FemaleJersey,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleStar',
    svg: FemaleStar,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleVNeckDeep',
    svg: FemaleVNeckDeep,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleCollaredPlain',
    svg: FemaleCollaredPlain,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleLeatherJacket',
    svg: FemaleLeatherJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleStripped',
    svg: FemaleStripped,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleVneck',
    svg: FemaleVneck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleButton',
    svg: FemaleButton,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleFloral',
    svg: FemaleFloral,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleMarshmallowJacket',
    svg: FemaleMarshmallowJacket,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleStrippedCollar',
    svg: FemaleStrippedCollar,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FemaleWideNeck',
    svg: FemaleWideNeck,
    positioning: {
      pointNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      pointMedium: {
        y: defaultY,
        scaleX: 1,
      },
      pointWide: {
        y: defaultY,
        scaleX: 1,
      },
      roundNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      roundMedium: {
        y: defaultY,
        scaleX: 1,
      },
      roundWide: {
        y: defaultY,
        scaleX: 1,
      },
      squareNarrow: {
        y: defaultY,
        scaleX: 1,
      },
      squareMedium: {
        y: defaultY,
        scaleX: 1,
      },
      squareWide: {
        y: defaultY,
        scaleX: 1,
      },
    },
  },
]

export default data
